<template>
  <span class="go-back" @click="goBack">
    <button ><v-icon dark medium> mdi-chevron-left </v-icon></button>
  </span>
</template>


<script>
export default {
  methods: {
    goBack() {
      return this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.go-back {
  display: flex;
  cursor: pointer;
  padding: 10px;
  background-color: black;
  width: fit-content;
}
.go-back:hover
{
  background-color: gray;
}

button {
  border: 0;
}


</style>
